// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EeZOao{display:flex;align-items:center;justify-content:center;color:white;text-decoration:none;text-align:center;white-space:nowrap;background-color:rgba(0,0,0,0.35);border-radius:0;border:none;outline:none;box-shadow:none;transition:background-color 0.2s;cursor:pointer;line-height:0 !important}.EeZOao:focus{outline:none;text-decoration:none;box-shadow:none}.EeZOao:hover,.EeZOao:active{text-decoration:none;background-color:rgba(0,0,0,0.7)}.EeZOao.WR9J6Y{border-radius:999px}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"action-button": `EeZOao`,
	"actionButton": `EeZOao`,
	"rounded": `WR9J6Y`
};
export default ___CSS_LOADER_EXPORT___;
